import { css } from '@emotion/core';
import { variables, media, rgba } from '@domain-group/fe-brary';
import * as pageStyles from '../allhomes-agency-profile-page.style';
var colour = variables.colour;
export var header = /*#__PURE__*/css();
export var noProfilePhoto = {
  name: "uewl2b",
  styles: "margin-bottom:20px;"
};
export var headerWrap = /*#__PURE__*/css("position:relative;width:100%;height:135px;text-align:center;max-height:360px;overflow:hidden;", media('>=tablet'), "{height:228px;}", media('>=desktop'), "{height:360px;}");
export var coverImageWrap = /*#__PURE__*/css("position:relative;height:100%;", media('>=tablet'), "{position:static;}");
export var coverImage = {
  name: "12qah06",
  styles: "display:block;width:100%;height:100%;object-fit:cover;"
};
export var profilePhoto = /*#__PURE__*/css("position:relative;width:100px;height:100px;border-radius:1px;background-color:", colour.white, ";box-shadow:0 5px 40px 0 ", rgba(colour.black, 0.1), ";border:5px solid ", colour.white, ";", media('>=tablet'), "{display:block;top:-82px;width:200px;height:200px;margin-left:8px;margin-top:0;}", media('>=desktop'), "{margin-left:24px;}");
export var profilePhotoImage = {
  name: "taozyx",
  styles: "position:absolute;top:0;right:0;bottom:0;left:0;max-width:100%;margin:auto;"
};
var _ref = {
  name: "if833e",
  styles: "margin-top:-61px;"
};
export var headerDetailsRow = _ref2 => {
  var photoPresent = _ref2.photoPresent;
  return /*#__PURE__*/css(pageStyles.insetBody, " display:flex;", photoPresent && _ref, " margin-bottom:24px;flex-direction:column;align-items:flex-start;", media('>=tablet'), "{flex-direction:row;align-items:flex-start;margin-top:32px;}");
};